// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___39k9e","inputContainer":"styles__inputContainer___qdcNN","iconContainer":"styles__iconContainer___2wWcu","icon":"styles__icon___16oMq"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/search/styles.css
// module id = 1183
// module chunks = 0